/** Matches grouped links in config/initializers/madmin.rb */

export const OPS_CONSOLE_HREF = "/madmin";
export const SUPPORT_CONSOLE_HREF = "/madmin/support";

/** Ops internal tools (also linked from config/initializers/madmin.rb). */
export const INTERNAL_TOOLS = {
  topics: {label: "Topics", href: "/ops/topics/page"},
  knowledge_atlas: {label: "Knowledge Atlas", href: "/ops/knowledge-atlas"},
  legislation_monitor: {label: "Legislation Monitor", href: "/ops/legislation-monitor"}
} as const;

export const PLATFORM_CONSOLE_SECTIONS = {
  document_pipeline: {
    label: "Document pipeline",
    href: "/documents",
  },
  grants: {
    label: "Grants",
    href: "/grants/new",
  },
  internal_tools: {
    label: "Internal tools",
    href: OPS_CONSOLE_HREF,
  },
  support: {
    label: "Support",
    href: "/support/team-user-status",
  },
} as const;

export type PlatformConsoleSectionKey = keyof typeof PLATFORM_CONSOLE_SECTIONS;
